/** Customer-safe archive retention messaging (P2-Batch-A). */

export const ARCHIVE_RETENTION_SUMMARY_COPY =
  'Twitch VODs can expire depending on broadcaster settings. Archive records in League Stream Center depend on source availability and your league workflow—they are not a promise of permanent Twitch storage.';

export const ARCHIVE_RETENTION_COMMISSIONER_COPY =
  'Review and publish important games while Twitch video is still available. Dry run can show what would qualify, but nothing publishes automatically yet.';

export const ARCHIVE_RETENTION_LIBRARY_HELP_COPY =
  'Published archives stay in your league library, but Twitch may stop hosting the video later. Copy links for league members who can sign in.';

export const ARCHIVE_RETENTION_SETTINGS_COPY =
  'Archive autopublish and dry run help you plan future publishing. They do not store Twitch video permanently or publish archives automatically yet.';

export const ARCHIVE_RETENTION_COMMAND_CENTER_COPY =
  'Stage 2 archive autopublish is for planning only today. Commissioner review remains required before anything appears in the member archive.';

export const ARCHIVE_COPY_LINK_VISIBILITY_REMINDER_COPY =
  'League members who can sign in may open this link. It is not a public or anonymous share.';

export const ARCHIVE_AUTOPUBLISH_WIZARD_STAGE2_EXPLAINER_ITEMS = [
  'Dry run shows what would happen without publishing.',
  'Controlled publishing is locked until post-launch Stage 2.',
  'Manual review remains the fallback.',
  'No archive will publish automatically yet.',
] as const;
